import { useQuery } from "@apollo/client";
import { ATTRIBUTE_PRODUCT_COUNT_QUERY } from "./queries";
import { NumberCard } from "../components/NumberCard";
import { TAXONOMY_CLIENT } from "../../../utils/consts";

export const ProductCountCard = (props: { attributeId: number }) => {
  const { data, loading } = useQuery(ATTRIBUTE_PRODUCT_COUNT_QUERY, {
    variables: {
      attributeId: props.attributeId,
    },
    skip: props.attributeId === 0,
    context: {
      clientName: TAXONOMY_CLIENT,
    },
  });

  return (
    <NumberCard
      id="product-count"
      isLoading={loading}
      count={data?.product.count || 0}
      title="Number of Products"
    />
  );
};
